import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_szjw5rycm7: FaireBrandEntity = {
  token: "b_szjw5rycm7",
  type: "brand",
  name: "Tala Mahj",
  avatarUrl:
    "https://cdn.faire.com/fastly/f0424b5e2f596ab79753e981d90a62d40c71eeb5f3192f2bc67999f778ac9fd2.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/7e196142cc54666aea099355077b51cfb5d7ee7a6de764340f82614291bd55cc.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f0424b5e2f596ab79753e981d90a62d40c71eeb5f3192f2bc67999f778ac9fd2.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7e196142cc54666aea099355077b51cfb5d7ee7a6de764340f82614291bd55cc.jpeg",
  location: "Daniel Island, SC, USA",
  minimumOrderDollars: 295,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    "Tala was born from the idea that the things we gather around should feel as beautiful as the moments themselves.\n\nWhile American mahjong has seen a wave of bold, colorful reinterpretations, Tala offers a quieter, more refined point of view—rooted in timeless design and elevated materials.\n\nBut beyond the aesthetic, mahjong is something more—it’s an invitation to slow down, to connect, and to step away. A few hours around the table becomes its own kind of escape, a ritual of play that feels both grounding and joyful.\n\nEach piece is created with longevity in mind, blending craftsmanship with a softened, neutral aesthetic that feels at home in any space.\n\nIt’s not just about the game—it’s about creating something you’ll reach for again and again, a space to gather and unwind, display on your table or shelf and ultimately, something to pass down.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:13.085Z",
    importedBy: "entity-db-cli",
  },
};
